import {
  ALL_MATCHES,
  NEW_MATCHES,
  CURRENT_MATCHES,
  PAST_MATCHES,
} from '@/constants/match-statuses';

const defaultState = {
  resultsMetaData: {
    [ALL_MATCHES.key]: {
      total: null,
      ids: [],
    },
    [NEW_MATCHES.key]: {
      total: null,
      ids: [],
    },
    [CURRENT_MATCHES.key]: {
      total: null,
      ids: [],
    },
    [PAST_MATCHES.key]: {
      total: null,
      ids: [],
    },
  },
  query: '',
  filterGroup: ALL_MATCHES,
  loading: false,
  loadingMore: false,
};

export default {
  namespaced: true,
  state () {
    return defaultState;
  },
  getters: {
    query (state) {
      return state.query;
    },
    loading (state) {
      return state.loading;
    },
    loadingMore (state) {
      return state.loadingMore;
    },
    allMetaData: state => state.resultsMetaData,
    filteredMetaData: state => state.resultsMetaData[state.filterGroup.key],
    hasMore (state, getters) {
      return getters.filteredMetaData.ids.length < getters.filteredMetaData.total;
    },
  },
  actions: {
    async search ({ commit, dispatch }, {
      groups = [ALL_MATCHES, NEW_MATCHES, CURRENT_MATCHES, PAST_MATCHES],
      reset = true,
      params,
      cancelToken,
    }) {
      // TODO (Volkan): enhance this
      if (reset) {
        commit('loading', true);
      } else {
        commit('loadingMore', true);
      }

      const promises = groups.map((group) => {
        return dispatch(
          'prohub/jobsStore/fetchJobs', {
            group,
            params,
            cancelToken,
          },
          { root: true }
        );
      });

      const responses = await Promise.all(promises);
      // Reset all off the data once
      // ALL of the promises return
      if (reset) { commit('reset'); }
      commit('updateQuery', { query: params.q });

      // For each response add jobs and update
      // meta data for the current group
      responses.forEach((response, index) => {
        commit('updateResultsMetaData', {
          // Get the current corresponding group
          // to response we are processing
          // TODO (Volkan): Make this not index based
          group: groups[index],
          total: response.data.total,
          results: response.data.results,
        });
      });
      commit('loading', false);
      commit('loadingMore', false);
    },
    loadMore ({ state, dispatch, getters }) {
      const group = state.filterGroup;

      dispatch('search', {
        groups: [group],
        reset: false,
        params: {
          q: state.query,
          from: getters.filteredMetaData.ids.length,
        },
      });
    },
    changeFilterGroup ({ commit }, group) {
      commit('updateFilterGroup', group);
    },
  },
  mutations: {
    loading (state, flag) {
      state.loading = flag;
    },
    loadingMore (state, flag) {
      state.loadingMore = flag;
    },
    reset (state) {
      Object.keys(state).forEach((key) => {
        state[key] = defaultState[key];
      });
    },
    updateQuery (state, { query }) {
      state.query = query;
    },
    updateFilterGroup (state, group) {
      state.filterGroup = group;
    },
    updateResultsMetaData (state, { group, total, results }) {
      const currentIds = state.resultsMetaData[group.key].ids;
      const resultIds = results.map(result => result.id);
      const uniqueIdSet = new Set([...currentIds, ...resultIds]);
      const uniqeIds = [...uniqueIdSet];

      state.resultsMetaData = {
        ...state.resultsMetaData,
        [group.key]: {
          total,
          ids: uniqeIds,
        },
      };
    },
  },
};
